import { createEffect, createEvent, sample } from 'effector';
import { spread } from 'patronum';
import { $$snackbar } from '../../../../components/SnackbarRoot/model';
import { ghApi } from '../../../../services/DataService';

const refreshKnowledgeBaseMtButtonClicked = createEvent<void>();
const refreshKnowledgeBaseStResellersButtonClicked = createEvent<void>();

const refreshKnowledgeBaseMtFx = createEffect<void, string>(async () => {
  return ghApi.post('/documentation/knowledgeBase/refresh/mt').then(res => res.data);
});

const refreshKnowledgeBaseStResellersFx = createEffect<void, string>(async () => {
  return ghApi.post('/documentation/knowledgeBase/refresh/st').then(res => res.data);
});

const $isRefreshKnowledgeBaseMtPending = refreshKnowledgeBaseMtFx.pending;
const $isRefreshKnowledgeBaseStResellersPending = refreshKnowledgeBaseStResellersFx.pending;

sample({
  clock: refreshKnowledgeBaseMtButtonClicked,
  target: refreshKnowledgeBaseMtFx
});

sample({
  clock: refreshKnowledgeBaseStResellersButtonClicked,
  target: refreshKnowledgeBaseStResellersFx
});

sample({
  clock: refreshKnowledgeBaseMtFx.doneData,
  fn: () => ({ message: 'Knowledge base refreshed for MT', severity: 'success' }),
  target: $$snackbar.open
});

sample({
  clock: refreshKnowledgeBaseStResellersFx.doneData,
  fn: () => ({ message: 'Knowledge base refreshed for ST resellers', severity: 'success' }),
  target: $$snackbar.open
});

sample({
  clock: refreshKnowledgeBaseMtFx.fail,
  fn: () => ({
    snackbarMessage: { message: `Error refreshing knowledge base for MT`, severity: 'error' }
  }),
  target: spread({
    snackbarMessage: $$snackbar.open
  })
});

sample({
  clock: refreshKnowledgeBaseStResellersFx.fail,
  fn: () => ({
    snackbarMessage: { message: `Error refreshing knowledge base for ST resellers`, severity: 'error' }
  }),
  target: spread({
    snackbarMessage: $$snackbar.open
  })
});

export const $$refreshKnowledgeBaseUtils = {
  $isRefreshKnowledgeBaseMtPending,
  $isRefreshKnowledgeBaseStResellersPending,
  refreshKnowledgeBaseMtButtonClicked,
  refreshKnowledgeBaseStResellersButtonClicked
};
